<template>
    <v-simple-table class="text-left w-100" dense style="border: 1px solid #d6d9da">
        <template #default>
            <tbody>
                <tr>
                    <td class="table-font table-title no-right-border primary-color w-65">
                        Treatment Plan Amount (After Coupons & Discounts)
                    </td>
                    <td class="table-font font-weight-bold no-left-border primary-color">
                        {{ formattedTreatmentTotal }}
                    </td>
                </tr>
                <tr>
                    <td class="table-font table-title no-right-border grey-darken-2 py-1">Credit Limit Requested</td>
                    <td class="table-font font-weight-bold no-left-border grey-darken-2">
                        {{ formattedCreditLimitRequested }}
                    </td>
                </tr>
                <tr>
                    <td class="table-font table-title no-right-border font-weight-bold primary-color bg-gray">
                        Remaining Patient Obligation
                    </td>
                    <td class="table-font font-weight-bold no-left-border primary-color bg-gray">
                        {{ formattedRemainingPatientObligation }}
                    </td>
                </tr>
            </tbody>
        </template>
    </v-simple-table>
</template>

<script>
    export default {
        name: "PaymentPlanDownPaymentTable",
        props: {
            formattedTreatmentTotal: {
                type: String,
                required: true,
            },
            formattedCreditLimitRequested: {
                type: String,
                required: true,
            },
            formattedRemainingPatientObligation: {
                type: String,
                required: true,
            },
        },
        data() {
            return {
                componentType: "PaymentPlanDownPaymentTable",
            }
        },

        computed: {},
    }
</script>
<style lang="scss">
    .table-title {
        width: 300px;
    }

    .bg-gray {
        background: $bg-color-neutral;
    }
</style>
